import React from "react";
import { useTranslation } from "react-i18next";

const DepositAndWithdraw = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`depositAndWithdraw.${key}`);
  return (
    <section className="w-full mt-[10px] rounded-[5] px-[10px] py-[16px] bg-base-light-white dark:bg-base-light-dark relative mb-[15px] flex flex-col items-center gap-[15px] font-medium">
      <h1 className="my-2 !mt-2 text-base-light-dark dark:text-base-light-white text-xl md:text-3xl font-semibold">
        {i18n("Deposit and consignment instructions")}
      </h1>
      <div className="text-base-deep-dark w-full dark:text-base-light-white">
        <div className="p-8 font-normal">
          <div className="mb-6 flex flex-col">
            {i18n("Deposit and consignment inner text")}
          </div>
          <div className="mb-6 flex flex-col">
            <span>ACB</span>
            <span>BIDV</span>
            <span>SACOMBANK</span>
            <span>VIETINBANK</span>
            <span>TECHCOM</span>
            <span>VIETCOMBANK</span>
            <span>ZaloPay</span>
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("Deposit and consignment inner text2")}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("Deposit and consignment inner text3")}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("Deposit and consignment inner text4")}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DepositAndWithdraw;
